import { supportedHomePages } from '../types';

export const isHomePage = (homePageSlug: string): boolean => supportedHomePages.includes(homePageSlug);
